/** @typedef {'project'|'context'|'person'|'parent'} TagEditorKind */
/** @typedef {'project'|'context'|'person'} InlineAddKind */

/**
 * @param {boolean} hasProject
 * @param {boolean} hasContext
 * @param {(key: string, fallback?: string) => string} t
 * @returns {Array<{ kind: TagEditorKind, label: string }>}
 */
export function buildAddMenuItems(hasProject, hasContext, t) {
  const items = [];
  if (!hasProject) {
    items.push({
      kind: /** @type {const} */ ('project'),
      label: t('taskform.addProject', 'Project toevoegen'),
    });
  }
  if (!hasContext) {
    items.push({
      kind: /** @type {const} */ ('context'),
      label: t('taskform.addContext', 'Context toevoegen'),
    });
  }
  items.push({
    kind: /** @type {const} */ ('person'),
    label: t('taskform.addPerson', 'Waiting for…'),
  });
  items.push({
    kind: /** @type {const} */ ('parent'),
    label: t('taskform.changeParent', 'Bovenliggende taak wijzigen'),
  });
  return items;
}

/**
 * @param {InlineAddKind|null} inlineAddKind
 * @param {string[]} projectOptions
 * @param {string[]} contextOptions
 * @param {string[]} personOptions
 */
export function getInlineTagOptions(
  inlineAddKind,
  projectOptions,
  contextOptions,
  personOptions,
) {
  if (inlineAddKind === 'project') return projectOptions;
  if (inlineAddKind === 'context') return contextOptions;
  return personOptions;
}

/**
 * @param {InlineAddKind|null} inlineAddKind
 * @param {(key: string, fallback?: string) => string} t
 */
export function getInlineTagPlaceholder(inlineAddKind, t) {
  if (inlineAddKind === 'project') {
    return t(
      'tasktagfields.projectPlaceholder',
      'Voeg project toe of selecteer',
    );
  }
  if (inlineAddKind === 'context') {
    return t('tasktagfields.contextsPlaceholder', 'Add or select contexts');
  }
  return t('tasktagfields.personPlaceholder', 'Waiting for…');
}

/**
 * @param {Object} params
 * @param {InlineAddKind|null} params.inlineAddKind
 * @param {string} params.inlineDraft
 * @param {unknown} params.rawValue
 * @param {(event: unknown, value: string[]) => void} params.handleProjectsChange
 * @param {(event: unknown, value: string[]) => void} params.handleContextsChange
 * @param {(event: unknown, value: string|null) => void} params.handlePersonChange
 * @param {() => void} params.cancelInlineAdd
 */
export function commitInlineTagAdd({
  inlineAddKind,
  inlineDraft,
  rawValue,
  handleProjectsChange,
  handleContextsChange,
  handlePersonChange,
  cancelInlineAdd,
}) {
  const value = String(rawValue ?? inlineDraft).trim();
  if (!value) {
    cancelInlineAdd();
    return;
  }

  if (inlineAddKind === 'project') {
    handleProjectsChange(null, [value]);
  } else if (inlineAddKind === 'context') {
    handleContextsChange(null, [value]);
  } else if (inlineAddKind === 'person') {
    handlePersonChange(null, value);
  }

  cancelInlineAdd();
}
